export default class ApiError {
  constructor(message, errors, code, responseData = null) {
    this.name = 'ApiError';
    this.message = message;
    this.errors = errors;
    this.code = code;
    this.responseData = responseData;
  }

  is(code) {
    return this.code === code;
  }
}
